/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
import _ from 'lodash'
var SceneExperienceTab = function ( editor ) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setId( 'sceneExperienceTab' );

	var selected = null;
	var values;

	function build() {

		container.clear();

		if ( selected === null ) return;

		values = {};

		//Select Scene Experience

		var row = new UI.Row();
		row.add(new UI.Text('Select Scene Experience').setWidth('90px'));
		container.add(row);

		var row = new UI.Row();
		container.add( row );
		var sceneExperienceSelection = new UI.Select()
		
		// set default string
		if (selected.name !== 'Unassigned Node') {
			if (selected.name.substr(0, 2) === 'AR') {
				if (selected.name.length === 2) {
					selected.name = 'AR with Back Camera on Image'
				}
				
			} else if (selected.name.substr(0, 2) === 'VR') {
				if (selected.name.length === 2) {
					selected.name = 'VR with Back Camera'
				}
			}
		}
		signals.animationRenamed.dispatch(selected);

		var sceneExperienceIndex = editor.sceneExperiences.findIndex(sceneExperience => sceneExperience === selected.name.substr(0, 2))		
		sceneExperienceIndex = sceneExperienceIndex === -1 ? 0 : sceneExperienceIndex
		sceneExperienceSelection.setOptions(editor.sceneExperiences.map((sceneExperience, i) => sceneExperience)).setValue( sceneExperienceIndex );
		sceneExperienceSelection.onChange( function () {
			selected.name = editor.sceneExperiences[parseInt(this.getValue())];
			if (selected.name.substr(0, 2) === 'AR') {				
				experienceTarget.setDisplay('inline')
				selected.name = 'AR with Back Camera on Image'
			} else {
				experienceTarget.setDisplay('none')
				selected.name = 'VR with Back Camera'
			}
			signals.animationRenamed.dispatch( selected );			
		} );
		row.add( sceneExperienceSelection );

		// + for camera option behind
		var plusSign = new UI.Text('+')
		row.add(plusSign)
		
		// select list for front and back camera
		var experienceCameraSelection = new UI.Select()
		var cameras = ['Front Camera', 'Back Camera']
		experienceCameraSelection.setOptions(cameras)

		let array = _.split(selected.name, ' ')		
		if (array[2] === 'Back') {			
			experienceCameraSelection.setValue(1)
		} else if (array[2] === 'Front') {
			experienceCameraSelection.setValue(0)			
		}

		experienceCameraSelection.onChange( function () {
			// substring AR and VR, remove camera selection on change			 
			selected.name = selected.name.substr(0, 2)
			selected.name += ' with ' + cameras[parseInt(this.getValue())]
			if (selected.name.substr(0, 2) === 'AR') {
				selected.name += ' on Image'
				experienceTarget.setValue(1)				
			}
			signals.animationRenamed.dispatch(selected)							
		})

		row.add(experienceCameraSelection)
		
		// Plane and Object option for AR
		var experienceTarget = new UI.Select()
		experienceTarget.setDisplay('none')
		if (selected.name.substr(0, 2) === 'AR') {			
			experienceTarget.setDisplay('inline')
		} else {
			experienceTarget.setDisplay('none')
		}
		
		var targets = ['Plane', 'Image', 'Object', 'Face']
		experienceTarget.setOptions(targets).setValue(targets[1])

		let currentArray = _.split(selected.name, ' ')
		if (currentArray[currentArray.length - 1] === 'Plane') {
			experienceTarget.setValue(0)
		} else if (currentArray[currentArray.length - 1] === 'Image') {
			experienceTarget.setValue(1)
		} else if (currentArray[currentArray.length - 1] === 'Object') {
			experienceTarget.setValue(2)
		} else if (currentArray[currentArray.length - 1] === 'Face') {
			experienceTarget.setValue(3)
		}

		experienceTarget.onChange( function () {			
			var target = targets[parseInt(this.getValue())]
			let array = _.split(selected.name, ' ')			
			if (array.length === 5) {
				selected.name += ' on ' + target				
			} else {
				if (array[array.length - 1] === 'Plane') {
					selected.name = _.replace(selected.name, 'Plane', target)					
				} else if (array[array.length - 1] === 'Image') {
					selected.name = _.replace(selected.name, 'Image', target)					
				} else if (array[array.length - 1] === 'Object') {
					selected.name = _.replace(selected.name, 'Object', target)
				} else if (array[array.length - 1] === 'Face') {
					selected.name = _.replace(selected.name, 'Face', target)
				}						
			}
			signals.animationRenamed.dispatch(selected)			
		})

		row.add(experienceTarget)
		// Time

		var row = new UI.Row();
		row.add(new UI.Text('Time').setWidth('45px'));
		container.add(row);

		var animationStart = new UI.Number(selected.start).setWidth('45px');
		animationStart.onChange(function () {

			selected.start = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(animationStart);

		var animationEnd = new UI.Number(selected.end).setWidth('45px');
		animationEnd.onChange(function () {

			selected.end = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(animationEnd);
	
	}

	//

	// signals.editorCleared.add( function () {

	// 	selected = null;
	// 	build();

	// } );

	signals.animationSelected.add( function ( animation ) {
		selected = animation;
		build();
	} );

	signals.animationModified.add(function (animation) {
		selected = animation;
		build();
	});


	signals.effectCompiled.add( build );

	/*
	signals.timeChanged.add( function () {

		if ( selected !== null ) {

			for ( var key in values ) {

				values[ key ].setValue( selected.module.parameters[ key ].value );

			}

		}

	} );
	*/

	return container;

};

export default SceneExperienceTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/SceneExperienceTab.js
// module id = null
// module chunks = 